export default __webpack_public_path__ + "static/media/3.9a0313d5.jpg";